export default __webpack_public_path__ + "static/media/confetti.fb26e303.gif";